<template lang="html">
<div class="chat_popup">
  <div class="contact-list" v-show="chatMode === 'list'">
    <div class="contact-header">
      Contacts
      <i class="el-icon-close pull-right close" style="margin-left:15px;" @click="setChatActive(false)"></i>
      <ElSwitch v-if="!isMrcConsultantOrBot" :value="chatStatus"
        active-text="On" inactive-text="Invisible"
        active-color="#13ce66" class="pull-right" @change="chatChanged">
      </ElSwitch>
    </div>
    <ElInput placeholder="Search..." size="mini" v-model="search"></ElInput>
    <div v-if="!isMrcBot" class="list-group-item bot" @click="chatWith(bot)">
      <i class="fa fa-user-circle-o fa-2x fa-fw left-icon" aria-hidden="true" style="color:rgb(66, 183, 42);"></i>{{bot.userName}}
      <br><span class="company-text">{{bot.company}}</span>
      <i class="fa float-vertical-align" :class="chatIcon(bot.userId)" aria-hidden="true"></i>
    </div>
    <div v-if="!isMrcConsultant" class="list-group-item consultant" @click="chatWith(consultant)">
      <i class="fa fa-user-circle-o fa-2x fa-fw left-icon" aria-hidden="true" style="color:rgb(66, 183, 42);"></i>{{consultant.userName}}
      <br><span class="company-text">{{consultant.company}}</span>
      <i class="fa float-vertical-align" :class="chatIcon(consultant.userId)" aria-hidden="true"></i>
    </div>
    <template v-if="isMrcConsultantOrBot || chatStatus">
      <div class="list-group-item" v-for="c in onlineSortedContacts" :key="c.userId" @click="chatWith(c)">
        <i class="fa fa-user-circle-o fa-2x fa-fw left-icon" aria-hidden="true" style="color:rgb(66, 183, 42);">
        </i>{{c.userName}} <br><span class="company-text">{{c.company || '-'}}</span>
        <i class="fa float-vertical-align" :class="chatIcon(c.userId)" aria-hidden="true"></i>
      </div>
      <div class="list-group-item offline" v-for="c in offlineContacts" :key="c.userId" @click="chatWith(c)">
        <i class="fa fa-user-circle-o fa-2x fa-fw left-icon" aria-hidden="true" style="color:#c4c6c9;">
        </i>{{c.userName}} <br><span class="company-text offline">{{c.company || '-'}}</span>
        <i class="fa float-vertical-align" :class="chatIcon(c.userId)" aria-hidden="true"></i>
      </div>
    </template>
  </div>
  <Chat v-show="chatMode === 'chat'" @back="backToChatList" ref="chat"
    :contactColor="contactColor" :contactTextColor="contactTextColor"
    :msges="chatUserMsges">
  </Chat>
</div>
</template>

<script>
import {
  mapState,
  mapActions,
  mapMutations,
} from 'vuex';
import {
  Col,
  Row,
  Button,
  Input,
  Switch,
  // Notification,
} from 'element-ui';
// import sortBy from 'lodash/sortBy';
import differenceBy from 'lodash/differenceBy';
import pullAt from 'lodash/pullAt';
import Chat from './Chat';

function compareContact(a, b) {
  if (a.company.toLowerCase() === b.company.toLowerCase()) {
    if (a.userName.toLowerCase() > b.userName.toLowerCase()) {
      return 1;
    }
    if (a.userName.toLowerCase() < b.userName.toLowerCase()) {
      return -1;
    }
    return 0;
  }
  if (a.company.toLowerCase() === 'mrc asia' && b.company.toLowerCase() !== 'mrc asia') {
    return 2;
  }
  if (a.company.toLowerCase() !== 'mrc asia' && b.company.toLowerCase() === 'mrc asia') {
    return -2;
  }
  if (a.company.toLowerCase() > b.company.toLowerCase()) {
    return 1;
  }
  if (a.company.toLowerCase() < b.company.toLowerCase()) {
    return -1;
  }
  return 0;
}

export default {
  data() {
    return {
      search: '',
      bot: {
        userName: 'MRC Employment Legislation Chatbot',
        userId: 'mrcchatbot@mrc-asia.com',
        company: 'MRC Asia',
      },
      consultant: {
        userName: 'MRC Consultant - Chat with us!',
        userId: 'mrcconsultant@mrc-asia.com',
        company: 'MRC Asia',
      },
    };
  },
  props: {
    msges: {
      required: true,
      type: Object,
    },
  },
  computed: {
    chatUserMsges() {
      if (this.chatMode === 'list') return [];
      return this.msges[this.chatUser.userId] || [];
    },
    contactColor() {
      if (this.chatUser.userId === this.bot.userId) {
        return {
          color: 'rgb(66, 183, 42)',
        };
      }
      if (this.chatUser.userId === this.consultant.userId) {
        return {
          color: 'rgb(66, 183, 42)',
        };
      }
      const i = this.onlineSortedContacts.findIndex(c => c.userId === this.chatUser.userId);
      if (i >= 0) {
        return {
          color: 'rgb(66, 183, 42)',
        };
      }
      return {
        color: '#c4c6c9',
      };
    },
    contactTextColor() {
      if (this.chatUser.userId === this.bot.userId) {
        return {
          color: 'black',
        };
      }
      if (this.chatUser.userId === this.consultant.userId) {
        return {
          color: 'black',
        };
      }
      const i = this.onlineSortedContacts.findIndex(c => c.userId === this.chatUser.userId);
      if (i >= 0) {
        return {
          color: 'black',
        };
      }
      return {
        color: '#848689',
      };
    },
    onlineSortedContacts() {
      if (Object.keys(this.contacts).length === 0) return [];
      let online = this.onlineContacts.map(c => this.contacts[c.userId])
        .filter(c => c && c.userId !== this.currentUser.userid);
      const search = this.search.trimLeft().toLowerCase();
      if (search) {
        online = online.filter(c => c.userName.toLowerCase().includes(search));
      }
      online.sort(compareContact);
      const poses = [];
      online.forEach((c, pos) => {
        const userMsges = this.msges[c.userId] || [];
        const i = userMsges.findIndex(msg => msg.readTimestamp === '');
        if (i >= 0) {
          poses.push(pos);
        }
      });
      const withUnread = pullAt(online, poses);
      online.unshift(...withUnread);
      return online;
      // return sortBy(online, ['company', 'userName']);
    },
    offlineContacts() {
      const all = Object.keys(this.contacts).map(id => this.contacts[id]);
      let offline = differenceBy(all, this.onlineContacts, 'userId')
        .filter(c => c && c.userId !== this.currentUser.userid);
      const search = this.search.trimLeft().toLowerCase();
      if (search) {
        offline = offline.filter(c => c.userName.toLowerCase().includes(search));
      }
      offline.sort(compareContact);
      const poses = [];
      offline.forEach((c, pos) => {
        const userMsges = this.msges[c.userId] || [];
        const i = userMsges.findIndex(msg => msg.readTimestamp === '');
        if (i >= 0) {
          poses.push(pos);
        }
      });
      const withUnread = pullAt(offline, poses);
      offline.unshift(...withUnread);
      return offline;
      // return sortBy(, ['company', 'userName']);
    },
    isMrcConsultantOrBot() {
      if (this.currentUser.userid === 'mrcconsultant@mrc-asia.com' || this.currentUser.userid === 'mrcchatbot@mrc-asia.com') {
        return true;
      }
      return false;
    },
    isMrcBot() {
      if (this.currentUser.userid === 'mrcchatbot@mrc-asia.com') {
        return true;
      }
      return false;
    },
    isMrcConsultant() {
      if (this.currentUser.userid === 'mrcconsultant@mrc-asia.com') {
        return true;
      }
      return false;
    },
    ...mapState(['onlineContacts', 'contacts', 'currentUser', 'chatStatus', 'chatMode', 'chatUser']),
  },
  methods: {
    chatChanged(status) {
      if (!status) {
        this.disableChat();
      } else {
        this.enableChat();
      }
    },
    chatIcon(userId) {
      if (!this.msges[userId]) return 'fa-comment-o';
      const userMsges = this.msges[userId];
      const i = userMsges.findIndex(msg => msg.readTimestamp === ''
        && msg.fromUserId !== this.currentUser.userid);
      if (i >= 0) {
        return 'fa-commenting unread-color fa-lg';
      }
      return 'fa-comment-o';
    },
    scrollToEnd() {
      this.$refs.chat.scrollToEnd();
    },
    ...mapActions(['disableChat', 'enableChat', 'chatWith']),
    ...mapMutations(['backToChatList', 'setChatActive']),
  },
  components: {
    ElRow: Row,
    ElCol: Col,
    ElButton: Button,
    Chat,
    ElInput: Input,
    ElSwitch: Switch,
  },
};
</script>

<style lang="scss" scoped>
.unread-color{
  color: #F7BA2A;
}
.float-vertical-align {
  position: absolute;
  top: 50%;
  right: 0;
  margin-right: 10px;
  transform: translateY(-50%);
}
.contact-list {
    z-index: 0;
    height: 100%;
}
// margin: 0 10px;
.contact-header {
  font-size: 16px;
  font-weight: bold;
  padding:10px 10px;
}
.offline{
  color:#a4a6a9;
}
.list-group-item {
  font-size: 14px;
  // font-weight: bolder;
  position: relative;
  display: block;
  min-height: 20px;
  width: auto;
  padding: 8px 10px;
  cursor: pointer;
  // border-bottom: 1px solid rgba(0,0,0,.125);
  // border-right: 1px solid rgba(0,0,0,.125);
  margin-bottom: -1px;
  // border-bottom: 1px solid #DDD;
  .company-text{
    font-size: 12px;
  }
  .company-text.offline{
    color:#a4a6a9;
  }
  .left-icon{
    float: left;
    display: block;
    padding-top:3px;
    padding-right:5px;
  }
}
.bot{
  background-color: #FFFFCA;
}
.consultant{
  background-color: #DFFFDF;
}
.list-group-item:nth-child(2) {
    border-top-left-radius: .25rem;
    border-top-right-radius: .25rem;
}
.list-group-item:last-child {
    margin-bottom: 0;
    // border-bottom: 0;
    border-bottom-right-radius: .25rem;
    border-bottom-left-radius: .25rem;
}
// .list-group-item.active,
// .list-group-item.active:focus,
// .list-group-item.active:hover {
//     z-index: 2;
//     color: #fff;
//     background-color: #337ab7;
//     border-color: #337ab7;
// }
.list-group-item:focus,
.list-group-item:focus,
.list-group-item:hover,
.list-group-item:hover {
    color: #555;
    text-decoration: none;
    background-color: #e5e5e5;
}
.chat_popup {
  height: inherit;
  // padding: 16px;
  // height: 600px;
  overflow-y: auto;
}
.close{
  font-weight: bold;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// Chatbox.vue?70e874c6